import React from 'react'
import './styles/logo.css'
import { string } from 'prop-types'
import LOGO from '../../../assets/img/DOTlogo.jpg'

const DOTlogo = ({ className }) => (
  <img
    src={LOGO}
    className={className}
    alt="New York city department of Transportation logo"
  />
)

DOTlogo.propTypes = {
  className: string.isRequired,
}
export default DOTlogo



// WEBPACK FOOTER //
// ./src/components/Elements/DOTlogo/index.jsx